import script from "./PersonLog.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonLog.vue?vue&type=script&setup=true&lang=js"

import "./PersonLog.vue?vue&type=style&index=0&id=392305cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392305cc"]])

export default __exports__